import {
  Tabs,
  Card,
  Heading,
  TextStyle,
  Avatar,
  Button,
  Link
} from '@superops/ui-design-system';
import {
  Loader,
  EventEmitter,
  DateTimeFormatter,
  B1,
  CurrencyText,
  InlineEdit,
  getTranslatedText,
  DeleteModal,
  TEXT_LENGTH,
  AddProducts,
  AccessControl,
  useProduct,
  COMMON_CONSTANTS
} from '@nile/components';
import { convertMinutesToHours } from '@nile/mangifera/src/Utils/helpers';
import InlineText from '@nile/components/src/Components/InlineEdit/Components/InlineText';
import {
  GET_WORKLOG_ENTRIES,
  GET_WORKLOG_TIMER_ENTRIES,
  MockTicketClient,
  useCachedQuery,
  useNoCacheQuery,
  GET_ALL_TIMER_ENTRIES,
  UPDATE_WORKLOG_ENTRY,
  DELETE_WORKLOG_ENTRY
} from '@nile/graphql';
import { Tooltip } from 'react-clone-tippy';
import { useMutation } from '@apollo/client';
import React, { useEffect, useState, useCallback, useContext } from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import { SVGIcon } from '@superops/super-icons';
import styled from 'styled-components';
import { TicketContext } from '@nile/mangifera/src/Contexts';
import { isEmpty } from 'lodash';
import { removePropertiesForItProduct } from '@nile/itsm';
import { WORKLOG_ITEM_STATE } from '@nile/components/src/Constants/worklog';

const WorklogEntry = styled.div`
  border-radius: 10px;
  .inline-text-wrapper {
    margin-left: -5px;
  }
  .Superops-TextField--multiline > .Superops-TextField__Input {
    padding-left: 4px;
  }
`;

const Content = styled.div`
  line-break: anywhere;
  .subject {
    font-size: 14px !important;
    font-weight: 600;
    height: fit-content;
    white-space: pre-wrap;
    line-break: anywhere;

    .edit-icon {
      visibility: hidden;
      margin-left: 5px;
    }
  }
  .subject-name {
    height: 100%;
    line-height: 3.3rem;
    max-height: 110px;
    overflow: auto;
    padding-right: 5px;
  }
`;

function ProductWorklogs(props) {
  const {
    ticket,

    project,

    module,

    isDisabled,

    padding,

    intl,
    getItemsToInvoice,
    renderServiceCatalogModal
  } = props;
  const context = useContext(TicketContext);
  const getCalculatedPrice = (quantity, price) => {
    let amount = '0';
    if (quantity && price) {
      amount = quantity * price;
      if (typeof amount === 'number') {
        amount = amount.toString();
      }
    }
    return amount;
  };
  const getConditions = () => {
    const serviceItemCondition = {
      joinOperator: 'OR',
      operands: [
        {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'serviceCatalogItem.itemType',
              operator: 'is',
              value: 'PRODUCT'
            }
          ]
        },
        {
          joinOperator: 'AND',
          operands: [
            {
              attribute: 'serviceCatalogItem.itemType',
              operator: 'is',
              value: 'SERVICE'
            },
            {
              attribute: 'serviceCatalogItem.serviceTypeItem.offeringType',
              operator: 'is',
              value: 'QUANTITY'
            }
          ]
        }
      ]
    };
    switch (module) {
      case 'TICKET':
        return {
          joinOperator: 'AND',
          operands: [
            serviceItemCondition,
            {
              attribute: 'ticket.ticketId',
              operator: 'is',
              value: ticket.ticketId
            }
          ]
        };
      case 'PROJECT':
        return {
          joinOperator: 'AND',
          operands: [
            serviceItemCondition,
            {
              attribute: 'project.projectId',
              operator: 'is',
              value: project.projectId
            }
          ]
        };
      default:
        return null;
    }
  };
  const { loading, data, error, refetch } = useCachedQuery(
    GET_WORKLOG_ENTRIES,
    {
      variables: {
        worklogInput: {
          module: module,
          listInfo: {
            sort: {
              attribute: 'billDateTime',
              order: 'ASC'
            },
            condition: getConditions()
          }
        }
      },
      onCompleted(res) {
        if (res?.fetchWorklogEntries?.entries) {
          const entries =
            res?.fetchWorklogEntries?.entries.filter(
              (el) =>
                el?.status !== 'INVOICED' &&
                el?.status !== 'IGNORED' &&
                el?.status !== 'UNDER_CONTRACT' &&
                el?.billable
            ) || null;

          if (module === 'TICKET') {
            getItemsToInvoice('PRODUCTS', entries);
          } else {
            context.getItemsToInvoice('PRODUCTS', entries);
          }
        }
      }
    }
  );
  const refetchWorklogs = () => {
    refetch();
  };
  const [
    updateWorklogEntryWithInterceptor,
    { loading: updateLoading, data: updatedData, error: updatError }
  ] = useMutation(UPDATE_WORKLOG_ENTRY, {
    onCompleted(res) {
      if (res.editWorklogEntry) {
        refetchWorklogs();
      }
    }
  });

  const currentProduct = useProduct();
  async function updateWorklogEntry(variables) {
    try {
      const updatedPayload = removePropertiesForItProduct(
        variables,
        'editWorklogEntry',
        currentProduct
      );
      return await updateWorklogEntryWithInterceptor(updatedPayload);
    } catch (ex) {
      return ex;
    }
  }

  const [
    deleteWorklogEntry,
    { loading: deleteLoading, error: deleteError }
  ] = useMutation(DELETE_WORKLOG_ENTRY, {
    onCompleted() {
      refetchWorklogs();
    }
  });
  const deleteWorklog = (id) => {
    deleteWorklogEntry({
      variables: {
        deleteWorklogInput: {
          itemId: id
        }
      }
    });
  };

  useEffect(() => {
    EventEmitter.subscribe('refetchProductWorklogs', refetchWorklogs);
    return function cleanup() {
      EventEmitter.unsubscribe('refetchProductWorklogs');
    };
  }, []);

  if (loading && !props?.newLayout) {
    return (
      <div className="full-width">
        <Card>
          <Loader />
        </Card>
      </div>
    );
  }
  if (!data?.fetchWorklogEntries?.entries?.length && !props?.newLayout) {
    return '';
  }
  const worklogs = data?.fetchWorklogEntries?.entries;
  const invoicedItems =
    worklogs?.filter((el) => el.status === WORKLOG_ITEM_STATE.invoiced) || [];
  const updateProductWorklogEntry = (item, key, value, cb) => {
    const inputObj = {};
    inputObj[key] = value || '0';
    updateWorklogEntry({
      variables: {
        updateWorklogEntryInput: {
          ...inputObj,
          itemId: item.itemId
        }
      }
    }).then((res) => {
      if (res?.data?.editWorklogEntry) {
        cb('success', false);
      } else {
        cb('error', false);
      }
    });
  };

  const wrapperClassNames = [
    'full-width',
    padding && 'p20',
    props?.newLayout && 'p10',
    module === 'PROJECT' && 'pl20 pr-20'
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className={wrapperClassNames}>
      <div className={!props?.newLayout ? 'flex col g20' : ''}>
        {props?.newLayout ? (
          <div className="flex fx-sb p10">
            <div>
              <TextStyle weight="SemiBold">
                <FormattedMessage id="ticket.details.worklog.associatedProducts" />
              </TextStyle>

              {props?.newLayout && !isEmpty(worklogs) && !loading && (
                <div className="mt5">
                  <Button plain onClick={props?.onViewModeClick}>
                    {worklogs?.length}{' '}
                    {getTranslatedText(
                      intl,
                      'ticket.details.worklog.associatedProducts'
                    )}
                    {!isEmpty(invoicedItems)
                      ? `  •  ${invoicedItems?.length} ${getTranslatedText(
                          intl,
                          'invoiced.quote.onhover.tooltip'
                        )}`
                      : ''}
                  </Button>
                </div>
              )}

              {props?.newLayout && isEmpty(worklogs) && !loading && (
                <div className="mt5">
                  <TextStyle variation="subdued">
                    {getTranslatedText(intl, 'common.no.products.associated')}
                  </TextStyle>
                </div>
              )}
            </div>

            <div>
              <AccessControl
                roleToCheck={{
                  roles: ['tickets.edit', 'serviceCatalog.view']
                }}
                render={ticket?.ticketId && renderServiceCatalogModal}
              />
            </div>
          </div>
        ) : (
          <Heading element="h3">
            <B1 className="flex center g10 wrap">
              <FormattedMessage id="ticket.details.worklog.associatedProducts" />
            </B1>
          </Heading>
        )}

        {props?.newLayout && loading && (
          <div className="flex actr jctr p20">
            <Loader />
          </div>
        )}

        {!isEmpty(worklogs) && props?.mode !== 'viewOnly' && (
          <div className={`flex col ${props?.newLayout ? 'g10' : 'g20'}`}>
            {worklogs?.map((log) => {
              let disabled = isDisabled || log.status !== 'PENDING';
              const worklogItemClassNames = [
                'flex g10 action-show rounded-2xl',
                props?.newLayout && 'p10 work-item',
                disabled && 'cursor-not-allowed'
              ]
                .filter(Boolean)
                .join(' ');
              return (
                <WorklogEntry className={worklogItemClassNames}>
                  <div>
                    <SVGIcon name="Quantity" />
                  </div>
                  <div
                    className={`flex col g10 full-width ${
                      props?.newLayout ? 'wrap' : ''
                    }`}
                  >
                    <div className="flex astart g10 relative">
                      <TextStyle variation="strong">
                        <div
                          className="flex wrap word-break"
                          title={log.serviceCatalogItem.name}
                        >
                          {log.serviceCatalogItem.name}
                        </div>
                      </TextStyle>
                      {!disabled ? (
                        <div className="flex center g10 action-visibility mlauto">
                          <DeleteModal
                            description={getTranslatedText(
                              intl,
                              'ticket.details.products.delete.description'
                            )}
                            handleDeleteConfirmation={() => {
                              deleteWorklog(log.itemId);
                            }}
                            title={getTranslatedText(
                              intl,
                              'ticket.details.products.delete.title'
                            )}
                            plain
                          />
                        </div>
                      ) : (
                        <div className="flex center g10 mlauto">
                          <Tooltip
                            title={getTranslatedText(
                              intl,
                              'worklog.details.item.invoicedOrAudited'
                            )}
                            position="top-start"
                            inertia
                            trigger="mouseenter"
                            animation="shift"
                            animateFill={false}
                          >
                            <div className="flex actr g4 bg-green rounded-4px p5">
                              <SVGIcon name="InvoiceLogo" />
                              <TextStyle
                                variation="strong"
                                weight="regular"
                                uppercase
                              >
                                {getTranslatedText(
                                  intl,
                                  'invoiced.quote.onhover.tooltip'
                                )}
                              </TextStyle>
                            </div>
                          </Tooltip>
                        </div>
                      )}
                    </div>

                    {disabled ? (
                      <TextStyle variation="subdued">
                        <div className="flex wrap word-break">{log.notes}</div>
                      </TextStyle>
                    ) : (
                      <InlineText
                        multiline
                        variant="subdued"
                        defaultValue={log.notes}
                        saveValue={(value, cb) => {
                          const afterSave = (saveState, updateTab = true) => {
                            if (cb) cb(saveState);
                          };

                          updateProductWorklogEntry(
                            log,
                            'notes',
                            value,
                            afterSave
                          );
                        }}
                        maxLength={TEXT_LENGTH.size_9}
                      />
                    )}

                    <AccessControl
                      productToCheck={COMMON_CONSTANTS.MSP}
                      render={
                        <Content
                          className={`flex  ${
                            props?.newLayout ? 'wrap g10' : 'g20'
                          }`}
                        >
                          <div className="flex g10 center">
                            <FormattedMessage id="ticket.details.worklog.product.quantity" />
                            {disabled ? (
                              <div className="subject flex actr">
                                <div className="f11 flex center subject-name ml4">
                                  {log.qty || 0}
                                  <div className="ml-5">
                                    <FormattedMessage id="app.field.suffix.qty" />
                                  </div>
                                </div>
                              </div>
                            ) : (
                              <InlineText
                                defaultValue={log.qty}
                                input="number"
                                saveValue={(value, cb) => {
                                  const afterSave = (
                                    saveState,
                                    updateTab = true
                                  ) => {
                                    if (cb) cb(saveState);
                                  };

                                  updateProductWorklogEntry(
                                    log,
                                    'qty',
                                    value,
                                    afterSave
                                  );
                                }}
                                suffix={
                                  <FormattedMessage id="app.field.suffix.qty" />
                                }
                              />
                            )}
                          </div>
                          <div className="flex g10 center">
                            <FormattedMessage id="ticket.details.worklog.product.price" />
                            {disabled ? (
                              <div className="subject flex actr">
                                <div className="f11 flex center subject-name ml4">
                                  <CurrencyText value={log.unitPrice || 0} />
                                </div>
                              </div>
                            ) : (
                              <InlineText
                                type="currency"
                                input="number"
                                defaultValue={log.unitPrice}
                                saveValue={(value, cb) => {
                                  const afterSave = (
                                    saveState,
                                    updateTab = true
                                  ) => {
                                    if (cb) cb(saveState);
                                  };

                                  updateProductWorklogEntry(
                                    log,
                                    'unitPrice',
                                    value,
                                    afterSave
                                  );
                                }}
                                step="any"
                              />
                            )}
                          </div>
                        </Content>
                      }
                    />
                  </div>
                </WorklogEntry>
              );
            })}
          </div>
        )}
      </div>
    </div>
  );
}

export default injectIntl(ProductWorklogs);
